
import Vue from 'vue'
export default Vue.extend({
    name: 'LitterFeeTable',
    props: {
        priceInfo: Array,
    }
})
